import { track, useEditor, useReadonly } from '@tldraw/tldraw'
import { SelectionForegroundProps } from './Types'
import { MeasureMarks } from './MeasureMarks/MeasureMarks'
import { MaskSelectionForeground } from './MaskSelectionForeground/MaskSelectionForeground'
import { RotateSelectionForeground } from './RotateSelectionForeground/RotateSelectionForeground'
import { DefaultSelectionForeground } from './DefaultSelectionForeground/DefaultSelectionForeground'

const SelectionForeground = track(({ bounds, rotation }: SelectionForegroundProps) => {
  const editor = useEditor()
  const isReadonlyMode = useReadonly()

  if (isReadonlyMode) return null

  const showSelectedMeasureBounds = editor.isIn('select.measuring')

  return (
    <>
      <MaskSelectionForeground />
      <RotateSelectionForeground bounds={bounds} rotation={rotation} />
      {showSelectedMeasureBounds && <MeasureMarks selectedBounds={bounds} />}
      <DefaultSelectionForeground bounds={bounds} rotation={rotation} />
    </>
  )
})

export { SelectionForeground }
